import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import DashboardPage from "./pages/DashboardPage";
import PresentationPage from "./pages/PresentationPage";
import CourseEditorPage from "./pages/CourseEditorPage";
import PublicHomePage from "./pages/PublicHomePage";
import PublicCoursesPage from "./pages/PublicCoursesPage";
import PublicSchedulePage from "./pages/PublicSchedulePage";
import PublicInstructorsPage from "./pages/PublicInstructorsPage";
import InstructorProfilePage from "./pages/InstructorProfilePage";
import PublicRequestPage from "./pages/PublicRequestPage";
import PublicSponsorsPage from "./pages/PublicSponsorsPage";
import SponsorDashboard from "./pages/SponsorDashboard";
import SponsorSignupPage from "./pages/SponsorSignupPage";
import SponsorLoginPage from "./pages/SponsorLoginPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPasswordSetupPage from "./pages/AdminPasswordSetupPage";
import InstructorSetupPage from "./pages/InstructorSetupPage";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public-facing routes */}
        <Route path="/public" element={<PublicHomePage />} />
        <Route path="/public/courses" element={<PublicCoursesPage />} />
        <Route path="/public/courses/:courseId" element={<PublicCoursesPage />} />
        <Route path="/public/schedule" element={<PublicSchedulePage />} />
        <Route path="/public/instructors" element={<PublicInstructorsPage />} />
        <Route path="/public/instructors/:instructorId" element={<InstructorProfilePage />} />
        <Route path="/public/request" element={<PublicRequestPage />} />
        <Route path="/public/sponsors" element={<PublicSponsorsPage />} />
        
        {/* Auth routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/setup-password" element={<AdminPasswordSetupPage />} />
        <Route path="/instructor/setup" element={<InstructorSetupPage />} />
        
        {/* Sponsor routes */}
        <Route path="/sponsor/signup" element={<SponsorSignupPage />} />
        <Route path="/sponsor/login" element={<SponsorLoginPage />} />
        <Route path="/sponsor-dashboard" element={<SponsorDashboard />} />
        
        {/* Protected Admin/Presenter dashboard routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path="/present/:courseId" element={
          <ProtectedRoute>
            <PresentationPage />
          </ProtectedRoute>
        } />
        <Route path="/present/:courseId/:scheduledId" element={
          <ProtectedRoute>
            <PresentationPage />
          </ProtectedRoute>
        } />
        <Route path="/edit/:courseId" element={
          <ProtectedRoute>
            <CourseEditorPage />
          </ProtectedRoute>
        } />
        <Route path="/new" element={
          <ProtectedRoute>
            <CourseEditorPage />
          </ProtectedRoute>
        } />
        
        {/* Root redirects to public site */}
        <Route path="/" element={<Navigate to="/public" replace />} />
        <Route path="*" element={<Navigate to="/public" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
